import React from 'react'

import StacktraceList from './StacktraceList'
import StacktraceLoader from './_load/StacktraceLoader'

const StacktraceTab = props => {
  return (
    <StacktraceLoader>
      <StacktraceList />
    </StacktraceLoader>
  )
}

export default StacktraceTab
